import { useState } from "react";
import { useTranslation } from "react-i18next";
import Select from 'react-select'
import { ZoneNameCommanDDL } from "../../../../../../../../../Components/IllegalDDL/ZoneNameCommanDDL";
import { PathakNumberCodeDDL } from "../../../../../../../../../Components/IllegalDDL/PathakNumberCodeDDL";
import { ShiftCommanDDL } from "../../../../../../../../../Components/IllegalDDL/ShiftCommanDDL";
import { AreaCommanDDL } from "../../../../../../../../../Components/IllegalDDL/AreaCommanDDL";


const SchedulePopUp = ({ handleSchedule, message }) => {

    const { t } = useTranslation()

    const [DDLID, setDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const options = [
        { id: 1, value: 1, label: '1' },
        { id: 2, value: 2, label: '2' },
    ]
    const [ZoneNameID, setZoneNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [PathakNumberID, setPathakNumberID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: sessionStorage.getItem('LanguageChange')
    })

    return (<>
        <div className="modal fade show" style={{ display: "flex", alignItems: 'center', backgroundColor: "#00000090" }}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content p-3">
                    <div className="modal-header pt-0">

                        <h5 className="card-title fw-bold" id="exampleModalLongTitle">{message}</h5>
                        <button onClick={() => handleSchedule()} type="button" className="close" style={{ marginLeft: "auto" }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">

                        <div className="row " >
                            <div className="col-12 col-lg-6 pt-3">
                                <label for="fname" className=" pb-2">{t('EncroachmentDashboard.OrderDate')}</label><br />
                                <input type="date" placeholder="" name="date" className="form-control" id="email" required />
                            </div>

                            <div className="col-12 col-lg-6 pt-3">
                                <label for="fname" className=" pb-2">{t('EncroachmentDashboard.OrderNumber')}</label><br />
                                <Select
                                    id='DDLID'
                                    isClearable={false}
                                    // isRtl={isRtl}
                                    isSearchable
                                    maxMenuHeight={130}
                                    value={{ value: DDLID.ID, label: DDLID.Label }}
                                    onChange={(e) => {
                                        e ?
                                            setDDLID({ ...DDLID, ID: e.value, Label: e.label })
                                            :
                                            setDDLID({ ...DDLID, ID: 0, Label: "Select..." })

                                    }}
                                    options={options}
                                />
                            </div>

                            <div className="col-12 col-lg-6 pt-3">

                                <label for="fname" className=" pb-2">{t('EncroachmentDashboard.ScheduleDate')}</label><br />
                                <input type="date" placeholder="" name="date" className="form-control" id="email" required />
                            </div>


                            <div className="col-12 col-lg-6 pt-3">
                                <ShiftCommanDDL />
                            </div>

                            <div className="col-12 col-lg-6 pt-3">
                                <ZoneNameCommanDDL
                                    ZoneNameID={ZoneNameID}
                                    setZoneNameID={setZoneNameID}
                                    Flag='Insert'
                                    ApiFlag='Master'
                                    data=''
                                    IsPost=''
                                    Language={Language}
                                />
                            </div>


                            <div className="col-12 col-lg-6 pt-3">
                                <label for="fname" className=" pb-2">{t('EncroachmentDashboard.pathakNocode')} </label>

                                <PathakNumberCodeDDL
                                    ZoneNameID={ZoneNameID}
                                    PathakNumberID={PathakNumberID}
                                    setPathakNumberID={setPathakNumberID}
                                    ApiFlag='Master'
                                    Flag="Insert"
                                    data=''
                                    IsPost=''
                                    Language={Language}
                                />
                            </div>




                            <div className="col-12 col-lg-6 pt-3">
                                <label for="fname" className=" pb-2">  {t('EncroachmentDashboard.AreaName')} </label><br />
                                <AreaCommanDDL />
                            </div>


                            <div className="col-12 col-lg-3 pt-3">

                                <label for="fname" className=" pb-2">{t('EncroachmentDashboard.WorkTimefrom')}</label><br />
                                <input type="time" placeholder="" name="date" className="form-control" id="email" required />
                            </div>

                            <div className="col-12 col-lg-3 pt-3">

                                <label for="fname" className=" pb-2">{t('EncroachmentDashboard.workTimeTo')}</label><br />
                                <input type="time" placeholder="" name="date" className="form-control" id="email" required />
                            </div>



                            <div className="col-12 col-lg-6 pt-3">

                                <label for="fname" className=" pb-2">{t('EncroachmentDashboard.Remark')}</label><br />
                                <input type="text" placeholder="Remark" name="date" className="form-control" id="email" required />
                            </div>












                            <div className="row">
                                <div className="col-12 pt-3 text-center">
                                    <div className="justify-content-between">
                                        <button
                                            type='button'
                                            onClick={() => handleSchedule()}
                                            className="w-80 btn addbtn btn-success btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                            Schedule
                                        </button>
                                        <button
                                            type="button"
                                            onClick={handleSchedule}
                                            className="w-80  btn addbtn btn-danger btn-brand btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u m-2 px-4" data-ktwizard-type="action-next">
                                            <i className="fa-solid fa-xmark"></i> Cancel
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </>);
}

export default SchedulePopUp;